import { Container, Flex, Text } from "@radix-ui/themes";
import { IMessage } from "../../../core/types/services-types/messages-types";
import React from "react";
import moment from 'moment'
import Avatar from "./avatar-render";
import { Link } from "react-router";
export interface MessageRenderProps {
    data: IMessage
}

export default function MessageRender(props: MessageRenderProps) {
    const {data} = props
    return (
        <Container className="!hover:bg-opacity-50">
            <Flex align={'center'} justify={'between'} wrap={'wrap'}>
                <Flex>
                <Avatar name={data.sender.login} />
                <Flex direction={'column'} className="w-[100%]">

                <Flex align={'center'} justify={'between'} className="w-[100%]">
                <Link to={`/profile/${data.sender.id}`}> 
                <Text size={'3'} weight={'bold'}> 
                {data.sender.login}
                </Text>
                </Link>

                <Text color='gray' size={'1'}>
                    {moment(data.updatedAt).format("DD:MM:YYYY HH:mm")}
                </Text>
                </Flex>

                <Text className="!self-start">
                {data.message}
                </Text>

                </Flex>

                </Flex>
            </Flex>
        </Container>
    )
}